module.exports = __webpack_public_path__ + "static/media/20ECE4.b0cea1fa.jpg";